// extracted by mini-css-extract-plugin
export default {"root":"GRNsPage_root__2-Vi9","version":"GRNsPage_version__AFAhe","header":"GRNsPage_header__sofc-","heading":"GRNsPage_heading__O-egv","filter":"GRNsPage_filter__tsc8H"};